import * as React from "react";

interface Props {
    color: string;
    fill?: string;
    size?: number;
}

export const Archived = (props: Props) => {
    const size = props.size ?? 24;

    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.726 7.18164V14.4544C15.726 15.0067 15.2783 15.4544 14.726 15.4544H5.27148C4.7192 15.4544 4.27148 15.0067 4.27148 14.4544V7.18164"
                fill={props.fill ?? undefined}
            />
            <path
                d="M15.726 7.18164V14.4544C15.726 15.0067 15.2783 15.4544 14.726 15.4544H5.27148C4.7192 15.4544 4.27148 15.0067 4.27148 14.4544V7.18164"
                stroke={props.color}
                strokeWidth="1.1"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.7 4H3.3C3.13431 4 3 4.13431 3 4.3V6.88182C3 7.0475 3.13431 7.18182 3.3 7.18182H16.7C16.8657 7.18182 17 7.0475 17 6.88182V4.3C17 4.13431 16.8657 4 16.7 4Z"
                fill={props.fill ?? undefined}
                stroke={props.color}
                strokeWidth="1.1"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.85352 10.873H11.399"
                stroke={props.color}
                strokeWidth="1.1"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
